import { get, put, post } from "./api_helper"

const getBusinessPartnerListApi = params =>
  get("admin/master/company/list", params)

// const getYearListApi = ({ id }) => get(`admin/master/fabric/${id}/year/list`)
const getYearListApi = ({ id }) =>
  get(`admin/master/rtw-product/supplier-id/${id}/year/list`)

const getSeasonListApi = params => get("admin/master/season/list", params)

const getRTWProductIdsApi = supplierId =>
  get("admin/master/rtw-product/list", { supplierId })

const getFabricCompanyListApi = () =>
  get("admin/master/fabric-trading-company/list")

const getFabricIdsApi = params => get("admin/master/fabric/list", params)

const getFabricBunchBrandIdsApi = params =>
  get("admin/master/fabric/bunch-brand/list", params)

const getFabricSeasonIdsApi = () => get("admin/master/season/list")

const getFabricSeasonIdsApiV2 = (fabricCompanyId, bunch, brand, year) =>
  get(
    `admin/master/fabric/fabric-company/${fabricCompanyId}/bunch/${bunch}/brand/${brand}/year/${year}/season/list`
  )

// const getFabricYearListApi = ({id}) => get(`admin/master/fabric/${id}/year/list`)
const getFabricYearListApi = ({ id }) =>
  get(`rtw-product/supplier-id/${id}/year/list`)
// rtw-product/supplier-id/{supplierId}/year/list

const getFabricYearListApiV2 = (brand, bunch, id) =>
  get(
    `admin/master/fabric/fabric-company/${id}/bunch/${bunch}/brand/${brand}/year/list`
  )

const getFabricWidthNRank = ({ fabricId, seasonId, year }) =>
  get(
    `admin/master/fabric/${fabricId}/latest-rank/year/${year}/season/${seasonId}`
  )

// const getProductDetailApi = ({ id }) => get(`admin/master/rtw-product/${id}`)
const getProductDetailApi = params =>
  get(`admin/master/rtw-product/list`, params)

const getDesignResourceApi = param => get(`admin/rtw-order/${param}/list`)

const getFabricById = id => get(`admin/master/fabric/${id}`)

export {
  getBusinessPartnerListApi,
  getYearListApi,
  getSeasonListApi,
  getRTWProductIdsApi,
  getFabricCompanyListApi,
  getFabricIdsApi,
  getFabricWidthNRank,
  getDesignResourceApi,
  getProductDetailApi,
  getFabricSeasonIdsApi,
  getFabricYearListApi,
  getFabricBunchBrandIdsApi,
  getFabricYearListApiV2,
  getFabricSeasonIdsApiV2,
  getFabricById,
}
